import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";
import Fonts from "./fonts";
import Colors from "./colors";

const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1600,
  xxl: 1920,
};

function createThemeMui({
  backgroundColor,
  secondaryBackgroundColor,
  paperBackgroundColor,
  paperSecondaryBackgroundColor,
  backgroundDisabled,
  textDisabledColor,
  textPrimaryColor,
  textSecondaryColor,
  textTertiaryColor,
  textQuaternary,
  buttonTextColor,
  buttonBackgroundColor,
  contrastColor,
  tertiaryBackgroundColor,
  associatedBackgroundColor,
}) {
  return createTheme({
    MediaQueries: {
      smUp: `@media only screen and (min-width: ${breakpointValues.sm + 1}px)`,
      smDown: `@media only screen and (max-width: ${breakpointValues.sm}px)`,
      mdUp: `@media only screen and (min-width: ${breakpointValues.md + 1}px)`,
      mdDown: `@media only screen and (max-width: ${breakpointValues.md}px)`,
      lgUp: `@media only screen and (min-width: ${breakpointValues.lg + 1}px)`,
      lgDown: `@media only screen and (max-width: ${breakpointValues.lg}px)`,
      xlUp: `@media only screen and (min-width: ${breakpointValues.xl + 1}px)`,
      xlDown: `@media only screen and (max-width: ${breakpointValues.xl}px)`,
      xxlUp: `@media only screen and (min-width: ${
        breakpointValues.xxl + 1
      }px)`,
      xxlDown: `@media only screen and (max-width: ${breakpointValues.xxl}px)`,
    },
    breakpoints: {
      keys: ["xs", "sm", "md", "lg", "xl", "xxl"],
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1600,
        xxl: 1920,
      },
    },
    palette: {
      white: Colors.white,
      redError: Colors.redError,
      darkOpacity: Colors.darkOpacity,
      darkGray: Colors.darkGray,
      softGray: Colors.softGray,
      carbon: Colors.carbon,
      blue: Colors.blue,
      darkBlue: Colors.darkBlue,
      lightGray: Colors.lightGray,
      orange: Colors.orange,
      primary: {
        contrastText: buttonTextColor,
        main: buttonBackgroundColor,
      },
      secondary: {
        main: buttonTextColor,
        contrastText: buttonBackgroundColor,
      },
      error: {
        main: Colors.redError,
        contrastText: Colors.white,
      },
      text: {
        primary: textPrimaryColor,
        secondary: textSecondaryColor,
        tertiary: textTertiaryColor,
        quaternary: textQuaternary,
        disabled: textPrimaryColor + 99,
        hint: textPrimaryColor,
        divider: textPrimaryColor,
      },
      background: {
        paper: paperBackgroundColor,
        secondaryPaper: paperSecondaryBackgroundColor,
        default: backgroundColor,
        defaultHover: contrastColor,
        secondary: secondaryBackgroundColor,
        tertiary: tertiaryBackgroundColor,
        associated: associatedBackgroundColor,
        input: paperBackgroundColor,
      },
      action: {
        active: secondaryBackgroundColor,
        hover: textSecondaryColor + "60",
        hoverOpacity: 0.04,
        selected: textSecondaryColor,
        selectedOpacity: 0.08,
        disabled: textDisabledColor,
        disabledBackground: backgroundDisabled,
        disabledOpacity: 0.38,
        focus: "#6CFF00",
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
      },
      colors: {
        white: Colors.white,
        redError: Colors.redError,
        blue: Colors.blue,
        darkBlue: Colors.darkBlue,
        text: Colors.text,
      },
    },
    typography: {
      h1: {
        color: textTertiaryColor,
        fontFamily: Fonts.bold,
        fontSize: Fonts.sizes.medium,
      },

      h2: {
        color: textTertiaryColor,
        fontFamily: Fonts.roman,
        fontSize: Fonts.sizes.small,
        letterSpacing: "0.05em",
      },

      body1: {
        color: textSecondaryColor,
        fontFamily: Fonts.light,
        fontSize: "1rem",
        letterSpacing: "0.05em",
      },
      button: {
        fontFamily: Fonts.roman,
        fontSize: Fonts.sizes.small,
        color: textSecondaryColor,
        letterSpacing: "0em",
      },
    },
    shape: {
      borderRadius: 4,
    },
    overrides: {
      MuiPickersDay: {
        dayDisabled: {
          opacity: 0.3,
        },
      },
      MuiPickersMonth: {
        monthDisabled: {
          opacity: 0.3,
        },
      },
    },
  });
}

const Light = createThemeMui({
  backgroundColor: Colors.white,
  secondaryBackgroundColor: Colors.red,
  tertiaryBackgroundColor: Colors.yellow,
  associatedBackgroundColor: Colors.orange,

  paperBackgroundColor: Colors.softGray,
  paperSecondaryBackgroundColor: Colors.gray,

  backgroundDisabled: Colors.grayDisabled,

  textDisabledColor: Colors.gray,
  textPrimaryColor: Colors.carbon,
  textSecondaryColor: Colors.red,
  textTertiaryColor: Colors.white,
  textQuaternary: Colors.subGray,

  buttonTextColor: Colors.white,
  buttonBackgroundColor: Colors.red,
  contrastColor: Colors.darkBlue,
});

const AMCRED = createThemeMui({
  backgroundColor: Colors.softGray,
  secondaryBackgroundColor: Colors.orange,

  paperBackgroundColor: Colors.gray,
  paperSecondaryBackgroundColor: Colors.gray,

  backgroundDisabled: Colors.grayDisabled,

  textDisabledColor: Colors.black,
  textPrimaryColor: Colors.white,
  textSecondaryColor: Colors.orange,
  textTertiaryColor: Colors.blue,
  textQuaternary: Colors.subGray,

  buttonTextColor: Colors.white,
  buttonBackgroundColor: Colors.orange,
  contrastColor: Colors.darkBlue,
});

const Themes = {
  Light: responsiveFontSizes(Light),
  AMCRED: responsiveFontSizes(AMCRED),
};

export default Themes;
